/**
 * Product Complementary Component
 * Handles complementary product selections and carousel functionality
 */
document.addEventListener('DOMContentLoaded', () => {
  initializeProductComplementary();
  setupShopifyEditorEvents();
});

/**
 * Initialize the product complementary functionality
 */
function initializeProductComplementary() {
  // Cache DOM elements
  const complementaryCarousel = document.querySelector('.dvrw-product-complementary-carousel');
  const loadingElement = document.querySelector('.dvrw-product-complementary-loading');
  const productSelect = document.querySelector('.dvrw-product-complementary__content select');
  const prevArrowBtn = document.querySelector('.dvrw-product-complementary-arrows .slick-prev');
  const nextArrowBtn = document.querySelector('.dvrw-product-complementary-arrows .slick-next');

  // Exit if required elements aren't found
  if (!complementaryCarousel || !productSelect) {
    return;
  }

  // Initialize carousel
  initializeCarousel(complementaryCarousel, loadingElement);

  // Setup event listeners
  setupEventListeners(complementaryCarousel, prevArrowBtn, nextArrowBtn, productSelect);
}

/**
 * Initialize the product carousel with Slick
 * @param {HTMLElement} carousel - The carousel element
 * @param {HTMLElement} loadingElement - The loading indicator element
 */
function initializeCarousel(carousel, loadingElement) {
  // Destroy existing carousel if it was already initialized
  if ($(carousel).hasClass('slick-initialized')) {
    $(carousel).slick('unslick');
  }

  const section = carousel.closest('.dvrw-product-complementary-section');
  const slideCount = carousel.querySelectorAll('.dvrw-product-complementary-item').length;

  // Bei nur einem Item die (externen) Pfeile ausblenden und den Track linksbündig
  // stellen — Slick zentriert sonst den schmaleren Track (.slick-track margin:auto).
  // Carousel bleibt initialisiert, damit Slide-Größe und Abstände unverändert bleiben.
  if (section) {
    section.classList.toggle('dvrw-product-complementary-section--single', slideCount <= 1);
  }

  $(carousel).on('init', () => {
    if (loadingElement) loadingElement.style.display = 'none';
  });

  $(carousel).slick({
    infinite: false,
    slidesToShow: 1.5,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    prevArrow:
      '<button type="button" class="slick-prev custom-arrow" aria-label="Zurück"><svg width="24" height="24" viewBox="0 0 24 24"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg></button>',
    nextArrow:
      '<button type="button" class="slick-next custom-arrow" aria-label="Weiter"><svg width="24" height="24" viewBox="0 0 24 24"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/></svg></button>',
    responsive: [
      {
        breakpoint: 1120,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
}

/**
 * Setup all event listeners
 * @param {HTMLElement} carousel - The carousel element
 * @param {HTMLElement} prevArrowBtn - The previous arrow button
 * @param {HTMLElement} nextArrowBtn - The next arrow button
 * @param {HTMLElement} productSelect - The product selection dropdown
 */
function setupEventListeners(carousel, prevArrowBtn, nextArrowBtn, productSelect) {
  // Arrow navigation for carousel
  if (prevArrowBtn) {
    prevArrowBtn.addEventListener('click', () => {
      $(carousel).slick('slickPrev');
    });
  }

  if (nextArrowBtn) {
    nextArrowBtn.addEventListener('click', () => {
      $(carousel).slick('slickNext');
    });
  }

  // Product selection handler
  carousel.addEventListener('change', (event) => {
    if (event.target.matches('.dvrw-product-complementary__content select')) {
      handleProductSelection(event);
    }
  });
}

/**
 * Setup Shopify theme editor events
 */
function setupShopifyEditorEvents() {
  // Section events
  document.addEventListener('shopify:section:load', handleSectionLoad);
  document.addEventListener('shopify:section:unload', handleSectionUnload);
  document.addEventListener('shopify:section:select', handleSectionSelect);
  document.addEventListener('shopify:section:deselect', handleSectionDeselect);

  // Block events
  document.addEventListener('shopify:block:select', handleBlockSelect);
  document.addEventListener('shopify:block:deselect', handleBlockDeselect);
}

/**
 * Handle section load in theme editor
 * @param {Event} event - The section:load event
 */
function handleSectionLoad(event) {
  const sectionContainer = event.target;

  // Check if the loaded section is our product complementary section
  if (sectionContainer.querySelector('.dvrw-product-complementary-carousel')) {
    initializeProductComplementary();
  }
}

/**
 * Handle section unload in theme editor
 * @param {Event} event - The section:unload event
 */
function handleSectionUnload(event) {
  const sectionContainer = event.target;
  const carousel = sectionContainer.querySelector('.dvrw-product-complementary-carousel');

  // Destroy carousel when section is unloaded to prevent memory leaks
  if (carousel && $(carousel).hasClass('slick-initialized')) {
    $(carousel).slick('unslick');
  }
}

/**
 * Handle section select in theme editor
 * @param {Event} event - The section:select event
 */
function handleSectionSelect(event) {
  const sectionContainer = event.target;
  const carousel = sectionContainer.querySelector('.dvrw-product-complementary-carousel');

  // Refresh the carousel when section is selected
  if (carousel && $(carousel).hasClass('slick-initialized')) {
    $(carousel).slick('setPosition');
  }
}

/**
 * Handle section deselect in theme editor
 * @param {Event} event - The section:deselect event
 */
function handleSectionDeselect(event) {
  // Additional handling if needed
}

/**
 * Handle block select in theme editor
 * @param {Event} event - The block:select event
 */
function handleBlockSelect(event) {
  const blockId = event.detail.blockId;
  const sectionContainer = event.target;
  const carousel =
    sectionContainer.closest('.dvrw-product-complementary-carousel') ||
    sectionContainer.querySelector('.dvrw-product-complementary-carousel');

  if (carousel) {
    // Find the index of the selected block/slide
    const slideIndex = Array.from(carousel.children).findIndex(
      (slide) => slide.dataset.blockId === blockId
    );

    if (slideIndex !== -1 && $(carousel).hasClass('slick-initialized')) {
      $(carousel).slick('slickGoTo', slideIndex);
    }
  }
}

/**
 * Handle block deselect in theme editor
 * @param {Event} event - The block:deselect event
 */
function handleBlockDeselect(event) {
  // Additional handling if needed
}

/**
 * Handle product variant selection and add to cart
 * @param {Event} event - The change event
 */
function handleProductSelection(event) {
  // The duplicate checker will now handle this event
  // No need to implement any logic here anymore as the
  // event listener in ShopifyDuplicateProductChecker will catch it

  // If ShopifyDuplicateProductChecker isn't loaded for some reason,
  // fallback to the original implementation
  if (!window.ShopifyDuplicateProductChecker) {
    const variantId = event.target.value;

    if (!variantId) {
      console.error('No variant ID selected');
      return;
    }

    addSingleItems({ id: variantId, quantity: 1 })
      .then((response) => {
        // Notify of successful addition
        document.dispatchEvent(
          new CustomEvent('ajaxProduct:added', {
            detail: {
              product: response,
              variant: response.variant_id,
            },
          })
        );

        // Update cart state
        document.dispatchEvent(new CustomEvent('cart:updated'));

        // Reset select to default option
        resetSelectToDefault(event.target);
      })
      .catch((error) => {
        const errorMessage = error.responseJSON
          ? error.responseJSON.description
          : 'Fehler beim Hinzufügen zum Warenkorb';
        console.error('Shopify AJAX add to cart error:', errorMessage);
      });
  }
}

/**
 * Reset select element to its first option
 * @param {HTMLSelectElement} selectElement - The select element to reset
 */
function resetSelectToDefault(selectElement) {
  selectElement.selectedIndex = 0;
}

/**
 * Add a single item to cart with retry mechanism
 * @param {Object} item - Item object with id and quantity
 * @param {number} retries - Number of retry attempts
 * @returns {Promise} - Promise resolving to cart response
 */
function addSingleItems(item, retries = 3) {
  return new Promise((resolve, reject) => {
    const shopifyRoot = window.Shopify.routes.root || '/';

    const attempt = (retriesLeft) => {
      fetch(`${shopifyRoot}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ items: [item] }),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then(resolve)
        .catch((error) => {
          if (retriesLeft > 0) {
            // Retry after a delay
            setTimeout(() => {
              attempt(retriesLeft - 1);
            }, 1000);
          } else {
            reject(error);
          }
        });
    };

    attempt(retries);
  });
}
